window.Loading = require('../src/loadings.js');
window.Position = require('../src/positions.js');
window.Transmit = require('../src/transmits.js');
window.Voyage = require('../src/voyages.js');
window.Tariff = require('../src/tariffs.js');
window.PlannedRoute = require('../src/planned_routes.js');
window.Booking = require('../src/bookings.js');
window.VesselSchedule = require('../src/vessel_schedules.js');